var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",staticClass:"text-bigger",class:_vm.isDark? 'text-white' : 'text-muted'},[_c('i',{staticClass:"far fa-share-square clickable",on:{"click":_vm.openModal}})])
}
var staticRenderFns = []

export { render, staticRenderFns }